import { render, staticRenderFns } from "./EmployeeListView.vue?vue&type=template&id=4510fdd5&scoped=true&"
import script from "./EmployeeListView.vue?vue&type=script&lang=ts&"
export * from "./EmployeeListView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4510fdd5",
  null
  
)

export default component.exports